import appGlobalScript from '/tmp/scratch/ticom-feature-components_BHcA9/src/global/index.ts';
export const globalScripts = appGlobalScript;
